import React, { useState, useEffect } from "react";
import { cloneDeep } from "lodash";
import { Dropdown, Menu, Radio, DatePicker, Button, message } from "antd";
import CustomFilter from "../../componentsShared/CustomFilter";
import FilterTags from "../../componentsShared/FilterTags";
import "./style.scss";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import moment from "moment";
import Cookies from "universal-cookie";

import { CUSTOM_FILTER_KEYS } from "../../constants/constants";
import * as filterDataHanler from "../../utils/filterDataHanler";

const ICON_EXPORT_EXCEL = require("../../assets/img/icons/ic-export-black.svg");
const ICON_ARROW_DOWN = require("../../assets/img/icons/ic-arrow-down-black.svg");
const ICON_CALENDAR = require("../../assets/img/icons/ic-calendar.svg");
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

var lastDate = new Date();
lastDate.setMonth(lastDate.getMonth() - 1);
var currentDate = new Date();

const cookies = new Cookies();

if (
  cookies.get("ta_startDate") &&
  cookies.get("ta_startDate") !== "" &&
  cookies.get("ta_startDate") !== "undefined"
) {
  currentDate = cookies.get("ta_startDate");
}
if (
  cookies.get("ta_endDate") &&
  cookies.get("ta_endDate") !== "" &&
  cookies.get("ta_endDate") !== "undefined"
) {
  lastDate = cookies.get("ta_endDate");
}

function printDocument() {
  message.loading("Exporting PDF...", 0);
  const input = document.querySelector("#divToPrint");
  html2canvas(
    input,
    { useCORS: true },
    {
      width: document.getElementById("divToPrint").scrollWidth,
      height: document.getElementById("divToPrint").scrollHeight,
    }
  ).then((canvas) => {
    canvas.crossOrigin = "Anonymous";
    const imgData = canvas.toDataURL("image/png");
    //document.querySelector("#divToPrint").appendChild(canvas);
    const pdf = new jsPDF();
    pdf.addImage(
      imgData,
      "png",
      0,
      0,
      document.getElementById("divToPrint").offsetWidth / 9,
      document.getElementById("divToPrint").offsetHeight / 9
    );
    pdf.save(new Date().valueOf() + ".pdf");
    message.destroy();
  });
}

const TeamActivityOverview = () => {
  useEffect(() => {
    if (cookies.get("email") == null) {
      document.location.href = "/";
    }
    cookies.set("ms_retailer", "");
    cookies.set("ms_merchandiser", "");
    cookies.set("ms_country", "");
    cookies.set("pr_brand", "");
    cookies.set("retailer", "");
    cookies.set("pc_retailer", "");
    cookies.set("pc_product", "");
    cookies.set("ig_startDate", "");
    cookies.set("ig_startDate", "");
    cookies.set("ig_placement", "");
    cookies.set("ig_retailer", "");
  }, []);
  // const [data, setData] = useState([]);
  // const [tableConfigs, setTableConfigs] = useState([]);
  const [periodFilter, setPeriodFilter] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [tagsData, setTagsData] = useState([]);

  const exportMenus = (
    <Menu>
      <Menu.Item key="pdf" onClick={printDocument}>
        PDF
      </Menu.Item>
      <Menu.Item key="1">Excel</Menu.Item>
    </Menu>
  );

  const handlePeriodFilterChange = (e) => {
    setPeriodFilter(e.target.value);
  };

  const onHandleFilterChanged = (data) => {
    setFilterData(data);
    convertDataForTags(data);
  };

  const convertDataForTags = (data) => {
    setTagsData(filterDataHanler.convertDataForTags(data));
  };

  const handleRemoveTag = (item) => {
    const data = filterDataHanler.removeTag(cloneDeep(filterData), item);
    setFilterData(data);
    convertDataForTags(data);
  };

  return (
    <div className="Team-Activity-Overview-wp">
      <div className="title-wp">
        <div className="title-wp">Team Activity Overview</div>
      </div>
      <div className="condition-values-wp">
        <FilterTags data={tagsData} onRemoveTag={handleRemoveTag} />
      </div>
      <div className="control-btns">
        {/*<Radio.Group
            className="period-filter-wp"
            value={periodFilter}
            onChange={handlePeriodFilterChange}
            style={{ marginRight: 15 }}
          >
            <Radio.Button value="monthly">Monthly</Radio.Button>
            <Radio.Button value="quarterly">Quarterly</Radio.Button>
            <Radio.Button value="yearly">Yearly</Radio.Button>
          </Radio.Group>
         <CustomFilter
            useFilterBtnForOverview={true}
            selectedData={filterData}
            filterKeys={[
              CUSTOM_FILTER_KEYS.COUNTRY_CODE_DROPDOWN
            ]}
            onChange={(data) => {
              console.log("TeamActivityOverview ####", data);
              onHandleFilterChanged(data);
            }}
          />*/}
        <div className="custom-calendar-wp">
          <img className="calendar-icon" alt="" src={ICON_CALENDAR} />
          {/*<DatePicker
              allowClear={false}
              onChange={(data) => {}}
              
              suffixIcon={<img alt="" src={ICON_ARROW_DOWN} />}
              disabledDate={(d) => !d || d.isAfter("2021")}
            />*/}
          <RangePicker
            showTime
            format={"YYYY-MM-DD"}
            onChange={(range) => {}}
            /*renderExtraFooter={() => (
                <Button
                  onClick={() => {document.location.href = "team-activity";}}
                  style={{ float: "right", margin: 10 }}
                >
                  OK
                </Button>
              )}*/
            onCalendarChange={(range) => {
              if (range[0] && range[1]) {
                var startDate = new Date(range[0]._d + "EDT")
                  .toISOString()
                  .split("T")[0];
                var endDate = new Date(range[1]._d + "EDT")
                  .toISOString()
                  .split("T")[0];
                cookies.set("ta_startDate", startDate);
                cookies.set("ta_endDate", endDate);
                document.location.href = "team-activity";
              }
            }}
            //picker="year"
            defaultValue={[
              moment(lastDate, dateFormat),
              moment(currentDate, dateFormat),
            ]}
            allowClear={false}
            suffixIcon={
              <img alt="" style={{ marginTop: "3px" }} src={ICON_ARROW_DOWN} />
            }
          />
        </div>
        {/*<Dropdown
          className="btn-item export-dropdown"
          overlay={exportMenus}
          trigger={["click"]}
        >
          <div>
            <img
              alt="icon-btn"
              className="arrow-icon"
              src={ICON_EXPORT_EXCEL}
            />
            <span>Export As</span>
            <img alt="" className="arrow-down-ic" src={ICON_ARROW_DOWN} />
          </div>
        </Dropdown>*/}
      </div>
    </div>
  );
};

export default TeamActivityOverview;
